/* eslint-disable consistent-return */
import React, { Component } from 'react';
import Relay from 'react-relay/classic';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

import AddQuestionSubmission from './NewObjectiveAssessmentMutations/AddQuestionSubmissionMutation';
import PerQuestionSubmission from './NewObjectiveAssessmentMutations/PerQuestionSubmissionMutation';
import flagQuestionCommand from './NewObjectiveAssessmentCommands/flagQuestionCommand';
import checkAnswerCommand from './NewObjectiveAssessmentCommands/checkAnswerCommand';
import startTimestampCommand from './NewObjectiveAssessmentCommands/startTimestampCommand';
import ResubmitAssignment from './NewObjectiveAssessmentMutations/ResubmitAssignmentMutation';
import NewObjectiveAssessment from '../NewObjectiveAssessment';
import { mtfFunction, ftbFunction, evaluateSelectResponse } from './helper';
import {
  getObjectiveResponseType,
  checkQuestionCompleted
} from '../NewObjectiveAssessment/helpers';

class ObjectiveAssignmentCard extends Component {
  componentDidMount() {
    window.hj && window.hj('tagRecording', ['ObjectiveAssignment']);
  }

  callAddQuestionSubmission = mutationProps => {
    const mutation = new AddQuestionSubmission(mutationProps);
    const promise = new Promise((resolve, reject) => {
      mutation.commit({
        onSuccess: d => {
          /* this.props.lessonProgressChangeCallback(
            this.props.rootQ.pid,
            this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure,
            this.props.rootQ
          ); */
          resolve(d);
        },
        onFailure: t => {
          reject(t.getError());
        }
      });
    });
    return promise;
  };

  callPerQuestionSubmission = mutationProps => {
    const mutation = new PerQuestionSubmission(mutationProps);
    const promise = new Promise((resolve, reject) => {
      mutation.commit({
        onSuccess: d => {
          /* this.props.lessonProgressChangeCallback(
            this.props.rootQ.pid,
            this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure,
            this.props.rootQ
          ); */
          resolve(d);
        },
        onFailure: t => {
          reject(t.getError());
        }
      });
    });
    return promise;
  };

  newAssessmentPlayerDispatch = async (type, payload) => {
    if (this.props.preview || this.props.guestMode) {
      return;
    }
    switch (type) {
      case 'FINISH_TEST': {
        const getRawScore = ({ answerEvaluation, maxScore, minScore, penaltyMarks }) => {
          if (answerEvaluation === 'TRUE') {
            return maxScore;
          }
          if (answerEvaluation === 'NA') {
            return minScore;
          }
          return minScore - penaltyMarks;
        };
        const { children } = payload.card;
        const answersList = [];
        const penaltyMarks =
          payload.card.isGradable && payload.card.questionSettings
            ? payload.card.questionSettings.penaltyMarks || 0
            : 0;
        children.forEach(item => {
          const questionType = getObjectiveResponseType(item.cardQuestion);
          switch (questionType) {
            case 'MATCH_THE_FOLLOWING': {
              const { cardQuestion, state } = item;
              const { maxScore = 1, minScore = 0, content } = cardQuestion;
              const { pairs } = content.question;
              const response = state.submissions ? state.submissions[0].response || '[]' : '[]';
              const parsedResponse = JSON.parse(response);
              const questionId = cardQuestion._id;
              const questionComplete = checkQuestionCompleted({
                currentQuestion: cardQuestion,
                currentQuestionState: state
              });
              const answerEvaluation = questionComplete
                ? mtfFunction.evalMTFAns(parsedResponse, pairs)
                : 'NA';
              const answer = {
                response,
                questionId,
                responseType: questionType,
                timeStamp: new Date().toISOString(),
                progressMeasure: 1,
                answerEvaluation,
                rawScore: getRawScore({ answerEvaluation, maxScore, minScore, penaltyMarks })
              };
              answersList.push(answer);
              break;
            }
            case 'FILL_IN_THE_BLANKS': {
              const { cardQuestion, state } = item;
              const { maxScore = 1, minScore = 0 } = cardQuestion;
              const response = state.submissions ? state.submissions[0].response || '{}' : '{}';
              let parsedResponse;
              try {
                parsedResponse = JSON.parse(response);
              } catch (err) {
                parsedResponse = {};
              }
              let answerEvaluation = 'FALSE';
              const questionId = cardQuestion._id;
              const questionComplete = checkQuestionCompleted({
                currentQuestion: cardQuestion,
                currentQuestionState: state
              });
              answerEvaluation = questionComplete
                ? ftbFunction.evalFTBAnswer(parsedResponse)
                : 'NA';
              const answer = {
                response,
                questionId,
                responseType: questionType,
                timeStamp: new Date().toISOString(),
                progressMeasure: 1,
                answerEvaluation,
                rawScore: getRawScore({ answerEvaluation, maxScore, minScore, penaltyMarks })
              };
              answersList.push(answer);
              break;
            }
            case 'MULTIPLE_SELECT':
            case 'SINGLE_SELECT': {
              const { cardQuestion, state } = item;
              const questionResponseType = getObjectiveResponseType(cardQuestion);
              const submission = state.submissions ? state.submissions[0] : null;
              const response = submission && submission.response ? submission.response : '';
              const { maxScore = 1, minScore = 0 } = cardQuestion;
              const { options } = cardQuestion.content.question;
              const questionId = cardQuestion._id;
              const questionComplete = checkQuestionCompleted({
                currentQuestion: cardQuestion,
                currentQuestionState: state
              });
              const answerEvaluation = questionComplete
                ? evaluateSelectResponse(response, options)
                : 'NA';
              const answer = {
                response,
                questionId,
                responseType: questionResponseType,
                timeStamp: new Date().toISOString(),
                progressMeasure: 1,
                answerEvaluation,
                rawScore: getRawScore({ answerEvaluation, maxScore, minScore, penaltyMarks })
              };
              answersList.push(answer);
              break;
            }
            default:
              break;
          }
        });
        const mutationProps = {
          isPayloadNeeded: false,
          rootOfferId: this.props.course && this.props.course.pid,
          userId: this.props.relay.variables.userId,
          cardId: this.props.rootQ.pid,
          answerArray: answersList,
          pathId: this.props.pathInfo && this.props.pathInfo.pid,
          actualSubmit: true // TODO: Don't know, from where to get this value
        };
        return this.callAddQuestionSubmission(mutationProps);
      }
      case 'START_TIMER_FOR_CARD': {
        return startTimestampCommand({
          rootOfferId: this.props.course && this.props.course.pid,
          userId: this.props.relay.variables.userId,
          cardId: this.props.rootQ.pid
        });
      }
      case 'FLAG_QUESTION': {
        const { currentQuestion, currentQuestionState } = payload;
        const questionId = currentQuestion._id;
        const currentFlagged = !!currentQuestionState.flagged;
        const { flagged = currentFlagged } = payload;
        return flagQuestionCommand({
          questionId,
          rootOfferId: this.props.course && this.props.course.pid,
          userId: this.props.relay.variables.userId,
          flagged
        });
      }
      case 'CHECK_ANSWER_CLICKED': {
        const { currentQuestion, currentQuestionState } = payload;
        const questionId = currentQuestion._id;
        const currentCheckAnswersAttemptCount = currentQuestionState.checkAnswersAttemptCount;
        const { checkAnswersAttemptCount = currentCheckAnswersAttemptCount } = payload;
        return checkAnswerCommand({
          questionId,
          rootOfferId: this.props.course && this.props.course.pid,
          userId: this.props.relay.variables.userId,
          checkAnswersAttemptCount
        });
      }
      case 'UPDATE_RESPONSE': {
        const questionCardContainer = this.questionCardContainer;
        if (questionCardContainer && questionCardContainer.showLoader) {
          questionCardContainer.showLoader();
        }
        const { currentQuestion, currentQuestionState } = payload;
        const currentResponse =
          currentQuestionState.submissions && currentQuestionState.submissions[0].response;
        const questionId = currentQuestion._id;
        const currentCheckAnswersAttemptCount = currentQuestionState.checkAnswersAttemptCount;
        const currentFlagged = !!currentQuestionState.flagged;
        const responseType = getObjectiveResponseType(currentQuestion);
        const {
          response = currentResponse || '',
          checkAnswersAttemptCount = currentCheckAnswersAttemptCount,
          flagged = currentFlagged
        } = payload;
        const isSubmit = false;
        const answerEvaluation = payload.answerEvaluation || 'NA';
        const rawScore = payload.rawScore || 0;
        const progressMeasure = isSubmit ? 1 : 0;
        return this.callPerQuestionSubmission(
          cloneDeep({
            rootOfferId: this.props.course && this.props.course.pid,
            userId: this.props.relay.variables.userId,
            cardId: this.props.rootQ.pid,
            answerObject: {
              questionId,
              response,
              answerEvaluation,
              timeStamp: new Date().toISOString(),
              responseType,
              rawScore,
              progressMeasure
            },
            flagged,
            checkAnswersAttemptCount,
            mainId: this.props.rootQ.id,
            actualSubmit: isSubmit,
            courseGraphId: this.props.course && this.props.course.id,
            pathId: this.props.pathInfo && this.props.pathInfo.pid,
            pathGraphId: this.props.pathInfo && this.props.pathInfo.id,
            coursePerformanceId:
              this.props.course &&
              this.props.course.coursePerformance &&
              this.props.course.coursePerformance.id,
            userGraphId: this.props.userObj.id
          }),
          questionCardContainer
        );
      }
      case 'TRY_AGAIN_ASSIGNMENT': {
        if (this.props.preview || this.props.guestMode) {
          break;
        }
        const mutation = new ResubmitAssignment({
          rootOfferId: this.props.course && this.props.course.pid,
          assignmentCardId: this.props.rootQ.pid,
          userId: this.props.relay.variables.userId,
          cardRelayId: this.props.rootQ.id,
          courseRelayId: this.props.course.id,
          timeStamp: new Date().toISOString()
        });
        const promise = new Promise((resolve, reject) => {
          mutation.commit({
            onSuccess: d => {
              /* this.props.lessonProgressChangeCallback(
                this.props.rootQ.pid,
                this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure,
                this.props.rootQ
              ); */
              console.log('Success: Try Again Assignment');
              resolve(d);
            },
            onFailure: t => {
              console.log('Failure: Try Again Assignment');
              reject(t.getError());
            }
          });
        });
        return promise;
      }
      case 'NEXT_QUESTION_PRESSED': {
        break;
      }
      case 'PREVIOUS_QUESTION_PRESSED': {
        break;
      }
      default:
        break;
    }
  };

  render() {
    const { isAssignmentFullScreen } = this.props;
    let cardData = {};
    try {
      cardData = JSON.parse(this.props.rootQ.rawData);
    } catch (err) {
      throw new Error('Invalid Data!');
    }
    return (
      <NewObjectiveAssessment
        ref={component => !!component && (this.questionCardContainer = component)}
        cardData={cardData}
        dispatch={this.newAssessmentPlayerDispatch}
        isMobile={this.props.isMobile}
        isAssignmentFullScreen={isAssignmentFullScreen}
        updateAssignmentScreenStatus={this.props.updateAssignmentScreenStatus}
        menuOpen={this.props.menuOpen}
        cardListMenuBtn={this.props.cardListMenuBtn}
        preview={this.props.preview}
        guestMode={this.props.guestMode}
      />
    );
  }
}

ObjectiveAssignmentCard.propTypes = {
  preview: PropTypes.bool,
  guestMode: PropTypes.bool
};

ObjectiveAssignmentCard.defaultProps = {
  preview: false,
  guestMode: false
};

export default Relay.createContainer(ObjectiveAssignmentCard, {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: () => Relay.QL`
      fragment on Card {
        id
        pid
        name
        rawData
        reAttemptAllowedCount
        minScaledScore
        hideAnswers
        isGradable
        performance(userId: $userId) {
          reAttemptCount
          scaledScore
          scaledProgressMeasure
        }
      }
    `
  }
});
